<template>
  <div class="gx-sw">
    <top-banner
      :nav-items="navItems"
      :unread="unreadCount"
      @logo="goHome"
      @nav="onNav"
      @bell="goNotification"
      @legacy="goLegacy"
      @logout="logout"
    />

    <div class="gx-layout">
      <!-- 侧栏 -->
      <aside class="gx-sw__sidebar" :style="{ width: collapsed ? '48px' : '210px' }">
        <button class="gx-sw__collapse" @click="collapsed = !collapsed">
          <span :style="{ transform: collapsed ? 'rotate(180deg)' : 'none' }">◀</span>
        </button>

        <nav class="gx-sw__nav">
          <button
            v-for="item in newUiVisibleItems('system', menu)"
            :key="item.id"
            class="gx-sw__item"
            :class="{ 'gx-sw__item--on': activeId === item.id }"
            :title="collapsed ? item.label : undefined"
            @click="go(item)"
          >
            <span class="gx-sw__item-icon">{{ item.icon }}</span>
            <span v-if="!collapsed" class="gx-sw__item-label">{{ item.label }}</span>
          </button>
          <div class="gx-sw__out">
            <button class="gx-sw__item" @click="outLoginVisible=true">
              <span class="gx-sw__item-icon">🚪</span>
              <span v-if="!collapsed" class="gx-sw__item-label">退出登录</span>
            </button>
          </div>
        </nav>
      </aside>

      <!-- 内容区 -->
      <main id="gx-main" class="gx-main">
        <!-- 工单管理 -->
        <new-ticket-page v-if="activeId === 'ticket'" />
        <!-- 岗位管理 -->
        <new-roles-page v-else-if="activeId === 'roles'" />
        <!-- 员工管理 -->
        <new-staff-page v-else-if="activeId === 'staff'" />
        <!-- 个人设置 -->
        <new-profile-page v-else-if="activeId === 'profile'" />
        <new-system-software-page v-else-if="activeId === 'software'" />

        <div v-if="outLoginVisible"  class="gx-modal">
          <div class="gx-modal-box gx-sw__modal-box--sm">
            <div class="gx-sw__out-body">
              <div class="gx-sw__out-body-icon">🚪</div>
              <div class="gx-sw__out-body-title">确认退出登录？</div>
              <div class="gx-sw__out-body-tip">退出后将返回首页，登录状态将被清除</div>
            </div>
            <div class="gx-sw__out-foot">
              <button class="gx-sw__out-foot-btn" @click="outLoginVisible=false">取消</button>
              <button class="gx-sw__out-foot-btn gx-sw__out-foot-btn--danger" @click="logout">确认退出</button>
            </div>
          </div>
        </div>
      </main>
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import TopBanner from '../../components/newUi/TopBanner.vue'
import NewTicketPage from '../ticket/index.vue'
import NewRolesPage from '../roles/index.vue'
import NewStaffPage from '../staff/index.vue'
import NewProfilePage from '../profile/index.vue'
import NewSystemSoftwarePage from '../systemSoftware/index.vue'
import newUiPermissionMixin from '../../mixins/newUiPermission'

export default {
  name: 'NewSystemWorkbenchPage',
  mixins: [newUiPermissionMixin],
  components: { TopBanner, NewTicketPage, NewRolesPage, NewStaffPage, NewProfilePage, NewSystemSoftwarePage },
  data() {
    return {
      navItems: [
        { id: null, label: '星人工作台' },
        // { id: 'agent', label: 'Agent工作台' },
        { id: 'shop', label: '店铺工作台' },
        { id: 'finance', label: '财务工作台' },
        { id: 'ops', label: '运营工作台' },
        // { id: 'select', label: '选品工作台' },
        { id: 'cloud', label: '云库工作台' },
        { id: 'presales', label: '售前工作台' },
        { id: 'aftersales', label: '售后工作台' },
        { id: 'system', label: '系统工作台', active: true }
      ],
      // 新版 wb-system 菜单（对照 ShopAdminPage.tsx WB_L2_DEFS["wb-system"]）
      menu: [
        { id: 'ticket', label: '工单管理', icon: '🎫', legacy: '/uc_ticket' },
        { id: 'roles', label: '岗位管理', icon: '👥', legacy: '/uc_position' },
        { id: 'staff', label: '员工管理', icon: '🧑‍💼', legacy: '/uc_employee' },
        { id: 'profile', label: '个人设置', icon: '⚙️', legacy: '/uc_setting' },
        { id: 'software', label: '桌面端&插件端下载入口', icon: '💾', legacy: '/new_uc_setting' }
      ],
      collapsed: false,
      activeId: 'ticket',
      outLoginVisible:false
    }
  },
  computed: {
    unreadCount() {
      const notifs = this.$store.state.notification.notifications || []
      return notifs.filter((n) => !n.isRead).length
    }
  },
  watch: {
    '$route.query.menu'(menu) {
      if (this.$route.path === '/new_system_workbench' && this.menu.some((item) => item.id === menu)) {
        this.activeId = menu
      }
    }
  },
  created() {
    const t = this.$route.query.menu
    if (t && this.menu.some((m) => m.id === t)) this.activeId = t
    this.$store.dispatch('notification/initNotificationWS')
  },
  methods: {
    ...mapMutations({
      OUT_LOGIN: 'login/OUT_LOGIN'
    }),
    go(item) {
      this.activeId = item.id
      if (this.$route.path !== '/new_system_workbench' || this.$route.query.menu !== item.id) {
        this.$router.replace({ path: '/new_system_workbench', query: { menu: item.id } }).catch(() => {})
      }
    },
    goLegacy() {
      this.$router.push('/ucenter_legacy')
    },
    onNav(id) {
      if (id === null) {
        this.$router.push('/ucenter')
        return
      }
      const map = {
        agent: '/new_uc_shop_manage',
        shop: '/new_uc_shop_manage',
        finance: '/new_finance_workbench',
        ops: '/new_ops_workbench',
        select: '/new_select_workbench',
        cloud: '/new_cloud_workbench',
        goods: '/new_goods_workbench',
        presales: '/new_presales_workbench',
        aftersales: '/new_aftersales_workbench',
        system: '/new_system_workbench'
      }
      const route = map[id]
      if (!route) {
        this.$message({ message: '该工作台功能开发中，敬请期待', type: 'warning' })
        return
      }
      this.$router.push(route)
    },
    goHome() {
      this.$router.push('/')
    },
    goNotification() {
      this.$router.push('/notification')
    },
    logout() {
      this.OUT_LOGIN()
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.gx-sw {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #F4F6F8;
}

.gx-sw__sidebar {
  flex-shrink: 0;
  background: #EEF1F6;
  border-right: 1px solid #DDE2EC;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  scrollbar-width: none;
  position: relative;
  transition: width .25s cubic-bezier(.4, 0, .2, 1);
}
.gx-sw__sidebar::-webkit-scrollbar {
  display: none;
}
.gx-sw__collapse {
  position: absolute;
  top: 10px;
  right: -12px;
  z-index: 20;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(212, 169, 70, .3);
  background: #EEF1F6;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .25s;
}
.gx-sw__collapse:hover {
  background: #1a2040;
  border-color: #D4A946;
}
.gx-sw__collapse span {
  font-size: 10px;
  color: #A0AEC0;
  display: inline-block;
  transition: transform .25s;
}
.gx-sw__nav {
  flex: 1;
  padding: 8px 0;
  overflow-y: auto;
  scrollbar-width: none;
}
.gx-sw__item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 9px 14px;
  border: none;
  border-left: 3px solid transparent;
  background: transparent;
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #5C6B73;
  text-align: left;
  transition: all .18s ease;
}
.gx-sw__item:hover {
  background: rgba(255, 255, 255, .72);
  color: #1A1A2E;
}
.gx-sw__item--on {
  background: #FFFFFF;
  border-left-color: #fa5757;
  color: #1A1A2E;
  font-weight: 600;
}
.gx-sw__item-icon {
  font-size: 15px;
  flex-shrink: 0;
}
.gx-sw__item-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gx-sw__out{
  margin-top: 8px;
  border-top: 1px solid rgb(225, 229, 238);
}
.gx-sw__out .gx-sw__item:hover{
  background: rgba(200,68,60,0.1);
  color: var(--gx-red);
}
/*弹窗*/
.gx-sw__modal-box--sm{
  max-width: 340px;
}
.gx-sw__out-body{
  padding: 22px 24px 24px;
  text-align: center;
}
.gx-sw__out-body-icon{
  font-size: 40px;
  margin-bottom: 10px;
}
.gx-sw__out-body-title{
  font-family: "Noto Serif SC", serif;
  font-size: 18px;
  font-weight: 700;
  color: rgb(26, 26, 46);
  margin-bottom: 8px;
}
.gx-sw__out-body-tip{
  font-family: "Noto Sans SC", sans-serif;
  font-size: 14px;
  color: rgb(74, 74, 106);
}
.gx-sw__out-foot{
  display: flex;
  border-top: 1px solid rgb(224, 224, 236);
}
.gx-sw__out-foot-btn{
  flex: 1;
  height: 48px;
  font-size: 15px;
  color: rgb(74, 74, 106);
  transition: 0.2s;
  cursor: pointer;
}
.gx-sw__out-foot-btn:hover{
  background: rgb(248,249,252);
}
.gx-sw__out-foot-btn--danger{
  font-weight: 600;
  color: var(--gx-red);
}
.gx-sw__out-foot-btn--danger:hover{
  background: rgb(255,240,238);
}
.gx-sw__out-foot-btn~.gx-sw__out-foot-btn{
  border-left: 1px solid rgb(224, 224, 236);
}
</style>
